import React from "react";
import AlertModal from "components/alertModal/AlertModal";
import useRoute from "hooks/useRoute";
import { useTranslation } from "react-i18next";

const LoginModal = () => {
    const { t } = useTranslation();
    const navigate = useRoute();

    return (
        <AlertModal
            alertMessage={t("common.alert.loginRequired")}
            trueFn={() => {
                navigate("/login", { state: { previousPage: window.location.href } });
            }}
            trueBtn={t("login.button.login")}
        />
    );
};

export default LoginModal;
